<template>
    <div class="kv-filter">
        <!-- <div class="kv-templates">
            <kv-button variant="text" prepend-icon="ui-filter-lines" icon-size="4" :active="filtersShow" @click="collapseFilters" />

            <kv-button v-for="template in templates" :key="template.name" :active="template.name === selectedTemplate" variant="outlined" @click="selectTemplateFilter(template)">
                {{ template.name }}
            </kv-button>
            <div class="kv-template-actions" :class="{ 'kv-show': draftTemplateFilter }">
                <input ref="templateInput" type="text" class="kv-button kv-outlined-button kv-active md" :placeholder="t('reports-filter_name')" v-model="filterTemplateName">
                <kv-button variant="text" :loading="savingFilter" active :title="t('code_editor-save')" prepend-icon="ui-check" @click="saveFilter" />
            </div>
        </div> -->
        <!-- <transition name="kv-collapse" @enter="filtersEnter" @after-enter="filtersAfterEnter" @leave="filtersLeave"> -->
        <!-- <div :v-show="filtersShow" ref="content" class="kv-collapse-content"> -->
        <div class="kv-filters d-flex justify-content-between align-items-end flex-wrap gap-md">
            <div class="d-flex align-items-end flex-wrap gap-md">

                <div v-for="filter in currentFiltersDetails" :key="'filter-' + filter.name">
                    <component :is="filter.component" :ref="filter.name" :currentValue="values[filter.name]" :options="filter.options" :name="filter.name" :label="filter.label" :allowReset="allowReset" :searchable="filter.searchable" @changed="setValue(filter.name, $event)" @remove="removeFilter(filter.name)" :removable="filter.removable">{{ filter.options }} </component>
                </div>


                <KvPopup v-if="availableFilters.length > 0" @after-close="addPendingFilters">
                    <template #trigger="{ toggle }">
                        <kv-button variant="tonal" icon-size="2" prepend-icon="ui-plus" @click="toggle">
                            {{ t('filter_bar-add_filter') }}
                        </kv-button>
                    </template>

                    <template #content="{ toggle }">
                        <span class="kv-popup-title">{{ t('filter_bar-select_filter') }}</span>
                        <div class="kv-popup-list">
                            <kv-button alignment="left" v-for="filter in availableFilters" :prepend-icon="filterIcon(filter)" variant="tonal" :key="filter.name" @click="pendingFilter = filter.name; toggle();">
                                {{ filter.label }}
                            </kv-button>
                        </div>
                    </template>
                </KvPopup>
            </div>
            <div v-if="hasValidFilters" class="kv-header-actions">
                <kv-button variant="tonal" prepend-icon="ui-trash-01" icon-size="2" @click="removeFilters">
                    {{ t('filter_bar-clear_filter') }}
                </kv-button>
                <!-- <kv-button variant="text" prepend-icon="ui-save-01" active icon-size="2" @click="toggleDraftFilter">
                            Salvar Filtros
                        </kv-button> -->
            </div>
        </div>

        <!-- </div> -->
        <!-- </transition> -->
        <!-- <div class="current-filters" :class="{ 'display-vertical': renderVertically }">
                <div v-for="filter in currentFiltersDetails" :key="'filter-' + filter.name" class="filter-container">
                    <label v-if="showLabels" class="filter-main-label">{{
                        filter.label
                    }}
                    </label>
                    <div class="filter" v-if="ready">
                        <div class="filter-body">
                            <component :is="filter.component" :ref="filter.name" :currentValue="values[filter.name]" :options="filter.options" :name="filter.name" :label="filter.label" :allowReset="allowReset" @changed="setValue(filter.name, $event)">{{ filter.options }}</component>
                        </div>
                        <span class="far fa-remove pull-right" v-if="filter.removable" @click="removeFilter(filter.name)"></span>
                    </div>
                </div>
                <div class="add-filter-holder">
                    <div class="filter add-filter" v-if="availableFilters.length > 0" @click="showAvailableFilters = !showAvailableFilters">
                        <span class="far fa-plus"></span>
                        <span v-if="renderVertically"> {{ t('filter_bar-add_filter') }}</span>
                    </div>
                    <div class="filter-options" v-if="showAvailableFilters">
                        <span class="far fa-remove pull-right" @click="showAvailableFilters = false"></span>
                        <label>{{ t('filter_bar-add_filter') }}</label>
                        <div class="clear"></div>
                        <ul>
                            <li v-for="filter in availableFilters" :key="filter.name" @click="addFilter(filter.name)">
                                {{ filter.label }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
    </div>
</template>
<style lang="less">
.kv-filters {
    min-height: 57.5px;
}

.kv-collapse-content {
    margin-top: 15px;
}

/* Transição */
.kv-collapse-enter-active,
.kv-collapse-leave-active {
    transition: max-height 0.4s ease;
    overflow: hidden;
}

.kv-templates {
    display: flex;
    gap: 10px;
    align-items: center;
    white-space: nowrap;
    flex-wrap: wrap;
}

.kv-collapse-filters {
    display: flex;

}

.kv-template-actions {
    display: flex;
    gap: 5px;
    width: 0;
    overflow: hidden;
}

.kv-template-actions.kv-show {
    width: 100%;
}

.kv-filter-label {
    font-size: 11px;
    color: #888;
    // position: absolute;
    // top: -16.5px;
    // left: 0;
}

.kv-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 200px;
    overflow-y: auto;
}

.kv-filter-container {
    position: relative
}

.kv-filter-input {
    display: flex;
    align-items: center;
    padding: 6px 9px;
    background-color: #F1FCF3;
    border-radius: 8px;
    gap: 10px;
    color: #2AAA4C;
    font-size: 13px;
    cursor: pointer;
    border: 1px solid transparent;
    height: 36px;
}

.kv-remove-filter {
    cursor: pointer;
    display: flex;
}
</style>
<script>
import FilterPeriod from "./filters/kv-period-filter.vue";
import FilterBranch from "./filters/kv-branch-filter.vue";
import FilterClient from "./filters/client";
import FilterMinMax from "./filters/min-max";
import FilterMinMaxWithPeriod from "./filters/min-max-with-relative-period";
import FilterMinMaxDates from "./filters/min-max-dates";
import FilterSelect from "./filters/select";
import FilterCheckbox from "./filters/kv-checkbox-filter";
import KvSelectFilter from "./filters/kv-select-filter.vue";
import FilterNumber from "./filters/number";
import FilterForm from "./filters/form";
import FilterTextField from "./filters/kv-textfield";
import { filter } from "minimatch";
import Icon from "../icon/icon";
import KvPopup from "../ui/kv-popup.vue";
import KvButton from "../form/kv-button.vue";

const ICON_MAP = {
    period: "ui-calendar",
    branch: "ui-building-01",
    client: "ui-user-01",
    "period-first-order": "ui-calendar-date",
    createdPeriod: "ui-shopping-cart-03",
    "client-segments": "ui-users-01",
    type: "ui-cursor-click-01",
    status: "ui-check-circle",
    assignee: "ui-user-square",
    automation_id: "ui-refresh-ccw-01",
    "task-due-date-period": "ui-calendar-check-02",
    "task-created-date-period": "ui-calendar-date",
    segment_id: "ui-users-01",
    tags: "ui-tag-01",
    read_state: "ui-mail-01",
    forms: "ui-file-02",
};

export default {
    name: "kv-filter",
    components: {
        period: FilterPeriod,
        branch: FilterBranch,
        client: FilterClient,
        "min-max": FilterMinMax,
        selectbox: FilterSelect,
        checkbox: FilterCheckbox,
        "kv-select": KvSelectFilter,
        "min-max-with-period": FilterMinMaxWithPeriod,
        "min-max-dates": FilterMinMaxDates,
        number: FilterNumber,
        textfield: FilterTextField,
        forms: FilterForm,
        Icon,
        KvPopup,
        KvButton
    },
    props: {
        showLabels: {
            type: Boolean,
            default: false,
        },
        hasBranchFilter: {
            type: Boolean,
            default: true,
        },
        hasClientFilter: {
            type: Boolean,
            default: false,
        },
        hasPeriodFilter: {
            type: Boolean,
            default: true,
        },
        hasFormFilter: {
            type: Boolean,
            default: false,
        },
        updateQueryString: {
            type: Boolean,
            default: true,
        },
        allowReset: {
            type: Boolean,
            default: false,
        },
        queryStringParam: {
            type: String,
            default: "filter"
        },
        filters: {
            type: Array,
            default: () => []
        },
        defaultSelected: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            ICON_MAP,
            showAvailableFilters: false,
            values: {},
            lastValuesEmitted: {},
            selectedFilters: [],
            defaultFilters: [],
            filtersShow: false,
            draftTemplateFilter: false,
            templates: [],
            selectedTemplate: "Todos",
            filterTemplateName: "",
            savingFilter: false,
            pendingFilter: null
        };
    },
    computed: {
        hasValidFilters() {
            return Object.values(this.values).some(value => {
                return value !== null && value !== undefined && value !== "";
            });
        },
        filterOptions() {
            // Merge default filters with provided filters, with provided filters taking precedence
            const mergedFilters = [...this.defaultFilters];

            if (this.filters && this.filters.length) {
                this.filters.forEach(filter => {
                    const existingIndex = mergedFilters.findIndex(f => f.name === filter.name);
                    if (existingIndex !== -1) {
                        mergedFilters[existingIndex] = filter;
                    } else {
                        mergedFilters.push(filter);
                    }
                });
            }

            return mergedFilters;
        },
        availableFilters() {
            return this.filterOptions.filter(
                filter => !this.selectedFilters.includes(filter.name)
            );
        },
        currentFiltersDetails() {
            return this.selectedFilters
                .map((filterName) => {
                    return this.filterOptions.find(item => item.name === filterName);
                })
                .filter((filter) => filter !== undefined);
        },
    },
    mounted() {
        this.initializeDefaultFilters();

        if (this.defaultSelected.length > 0) {
            this.defaultSelected.forEach(f => {
                if (!this.selectedFilters.includes(f)) {
                    this.addFilter(f, false);
                }
            });
            this.filtersShow = true; // já deixa visível
        }

        if (this.updateQueryString) {
            this.loadQueryStringFilter();
        }
        // const templates = this.getStoredFilterTemplates();
        // this.updateTemplates(templates);

        this.filtersShow = Object.keys(this.values).length > 0;
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        filterIcon(filter) {
            if (!filter) {
                return "ui-plus";
            }
            return filter.icon || ICON_MAP[filter.name] || "ui-plus";
        },
        addPendingFilters() {
            if (this.pendingFilter) {
                this.addFilter(this.pendingFilter);
                this.pendingFilter = null;
            }
        },
        selectTemplateFilter(template) {
            this.cleanFilters();
            this.selectedTemplate = template.name;
            this.setValues(template.data);
            this.changed();
            sessionStorage.setItem('kv-selected-template', template.name);
        },
        toggleDraftFilter() {
            this.draftTemplateFilter = !this.draftTemplateFilter;
            this.$refs.templateInput.focus();
        },
        getStoredFilterTemplates() {
            const stored = localStorage.getItem("kv-templates");
            let arr = [];

            if (stored) {
                try {
                    arr = JSON.parse(stored);
                    if (!Array.isArray(arr)) {
                        arr = [arr];
                    }
                } catch (e) {
                    arr = [];
                }
            }

            return arr;
        },
        updateTemplates(templates) {
            this.templates = [{ name: "Todos", data: {} }, ...templates];
        },
        async saveFilter() {
            if (this.filterTemplateName) {
                try {
                    this.savingFilter = true;

                    const newTemplate = {
                        name: this.filterTemplateName,
                        data: this.values
                    };

                    const existingTemplates = this.getStoredFilterTemplates();

                    const updatedTemplates = [...existingTemplates, newTemplate];

                    this.selectedTemplate = newTemplate.name;

                    // simula delay de 2 segundos
                    await new Promise(resolve => setTimeout(resolve, 2000));

                    localStorage.setItem(
                        "kv-templates",
                        JSON.stringify(updatedTemplates)
                    );

                    this.updateTemplates(updatedTemplates);

                    this.toggleDraftFilter();
                } finally {
                    this.savingFilter = false;
                }

            }
        },
        collapseFilters() {
            this.filtersShow = !this.filtersShow
        },
        filtersEnter(el) {
            el.style.maxHeight = '0'
            el.offsetHeight
            el.style.transition = 'max-height 0.43 ease'
            el.style.maxHeight = el.scrollHeight + 'px'
        },
        filtersAfterEnter(el) {
            el.style.maxHeight = 'none'
        },
        filtersLeave(el) {
            el.style.maxHeight = el.scrollHeight + 'px'
            el.offsetHeight
            el.style.transition = 'max-height 0.4s ease'
            el.style.maxHeight = '0'
        },
        filter,
        loadQueryStringFilter() {
            if (this.$route.query[this.queryStringParam]) {
                try {
                    const queryValues = JSON.parse(this.$route.query[this.queryStringParam]);
                    if (queryValues && typeof queryValues === "object" && !Array.isArray(queryValues)) {
                        this.values = queryValues;
                        this.$nextTick(() => {
                            for (let filter in this.values) {
                                if (!this.selectedFilters.includes(filter)) {
                                    this.addFilter(filter, false);
                                }
                            }
                        });
                        this.changed();
                    }
                } catch (e) {
                    console.error("Error parsing filter from query string", e);
                }
            }
        },
        initializeDefaultFilters() {
            if (this.hasPeriodFilter) {
                this.registerDefaultFilter({
                    component: "period",
                    label: this.t('filter_bar-period'),
                    removable: false,
                    name: "period",
                });
            }

            if (this.$root.$store?.state?.place?.branches?.length > 1 && this.hasBranchFilter) {
                this.registerDefaultFilter({
                    component: "branch",
                    label: this.t('filter_bar-branches'),
                    removable: true,
                    name: "branch",
                });
            }

            if (this.hasClientFilter) {
                this.registerDefaultFilter({
                    component: "client",
                    label: this.t('filter_bar-client'),
                    removable: true,
                    name: "client",
                });
            }

            if (this.hasFormFilter) {
                this.registerDefaultFilter({
                    component: "forms",
                    label: this.t('filter_bar-form'),
                    removable: true,
                    name: "forms",
                });
            }
        },
        registerDefaultFilter(filter) {
            if (filter.name === undefined) {
                filter.name = filter.component;
            }

            const existingFilterIndex = this.defaultFilters.findIndex(f => f.name === filter.name);

            if (existingFilterIndex !== -1) {
                this.defaultFilters.splice(existingFilterIndex, 1, filter);
            } else {
                this.defaultFilters.push(filter);
            }
        },
        registerFilter(filter) {
            // This method is kept for backward compatibility
            this.registerDefaultFilter(filter);
        },
        addFilter(filter, focus = true) {
            if (!this.selectedFilters.includes(filter)) {
                this.selectedFilters.push(filter);

                this.$nextTick(() => {
                    if (this.$refs[filter]) {
                        this.$refs[filter][0].focus = focus;
                    }
                });
            }

            this.showAvailableFilters = false;
        },
        removeFilter(filter) {
            const index = this.selectedFilters.indexOf(filter);
            if (index > -1) {
                this.selectedFilters.splice(index, 1);
                const tempValues = { ...this.values };
                if (tempValues[filter] !== undefined) {
                    delete tempValues[filter];
                }
                this.values = tempValues;
                this.changed();
            }
        },
        cleanFilters() {
            this.selectedFilters = [...this.defaultSelected];
        },
        cleanValues() {
            this.values = {};
        },
        removeFilters() {
            this.cleanFilters();
            this.cleanValues();
            this.selectedTemplate = "Todos";
            this.changed();
        },
        setValue(filter, event) {
            this.$set(this.values, filter, event);
            this.changed();
        },
        setValues(values) {
            for (let filter in values) {
                let value = values[filter];
                if (!this.selectedFilters.includes(filter) && value !== null) {
                    this.addFilter(filter, false);
                }
            }
            this.values = values;
        },
        changed() {
            let currentValues = JSON.stringify(this.values);
            if (currentValues !== this.lastValuesEmitted) {
                this.$emit("changed", { ...this.values });
                this.lastValuesEmitted = currentValues;
            }
        },
    },
    watch: {
        values: {
            handler() {
                if (this.updateQueryString) {
                    const oldQuery = JSON.parse(JSON.stringify(this.$route.query));
                    const newQuery = JSON.parse(JSON.stringify(this.$route.query));
                    newQuery[this.queryStringParam] = JSON.stringify(this.values);
                    if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
                        this.$router.replace({ query: newQuery }).catch(() => { });
                    }
                }
                this.draftTemplateFilter = false;
            },
            deep: true,
        },
    },
};
</script>
